import React, { useState, useEffect, useRef } from 'react';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import upDirectionAerrow from 'src/assets/svgs/upDirectionAerrow.svg';
import downDirectionAerrow from 'src/assets/svgs/downDirectionAerrow.svg';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { breakPoints } from 'src/constants/general';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Paginator } from 'primereact/paginator';
import { Tooltip } from 'flowbite-react';
import { BsInfoCircle } from 'react-icons/bs';
import { getRemovetzTime } from 'src/utils/function';

const ResponsiveEmployeeList = ({ employeeData, openAcoordionResponsive, setOpenAcoordionResponsive, getEmployee, isLoading, selectedRange, modalOpenEmployee }: any) => {
    const { isMobile }: any = useDeviceDetect();
    const [first, setFirst] = useState(0);
    const [page, setPage] = useState(0);

    const isFirstRender = useRef(true);

    const getJobsData = () => {
        let start = selectedRange?.start ? `&startDate=${selectedRange?.start}` : '';
        let end = selectedRange?.end ? `&endDate=${selectedRange?.end}` : '';
        let before = selectedRange?.before ? `&before=${selectedRange?.before}` : '';
        const url = `?page=${page}&limit=10${start}${end}${before}`;
        getEmployee(url, modalOpenEmployee);
    };
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        getJobsData();
    }, [page]);

    const onPageChange = (event: any) => {
        setFirst(event.first);
        setPage(event.page);
    };
    const GetJoinDate = (row: any) => getRemovetzTime(row.createdAt, 'MMM. DD, YY');

    return (
        <div className=" flex flex-col gap-2">
            {isLoading ? (
                <div className="card w-full h-[calc(100vh-300px)] flex justify-content-center items-center ">
                    <ProgressSpinner />
                </div>
            ) : (
                <>
                    {employeeData.emp?.length !== 0 &&
                        employeeData.emp?.map((data: any, index: number) => (
                            <div key={index} className={`${index === 0 ? '' : 'mt-3'}`}>
                                <div className={`w-full flex p-[10px] bg-white flex-col rounded-3xl ${openAcoordionResponsive === index ? '' : 'border-b-2 border-[#C1C1C1]'}`}>
                                    <button
                                        className={`flex items-center justify-between w-full`}
                                        onClick={() => setOpenAcoordionResponsive((preavState: any) => (preavState === index ? null : index))}
                                    >
                                        <div className="flex items-center gap-2">
                                            <img
                                                className="max-md:w-6 max-md:h-6 max-lg:w-[26px] max-lg:h-[26px] rounded-full"
                                                src={data.companyName === 'West' ? westImg : data.companyName === 'Log' ? logImg : data.companyName === 'Liani' ? lianiImg : fsImg}
                                                alt="img"
                                            />
                                            <div className="text-black max-md:text-xs font-bold font-['Satoshi Variable'] uppercase max-lg:text-sm">{data.companyName}</div>
                                        </div>
                                        <div className="flex items-center gap-2 ">
                                            {data.isAsap ? (
                                                <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center">
                                                    <TiFlash size={18} />
                                                </span>
                                            ) : (
                                                <span className="w-5 h-5 rounded-full flex justify-center items-center"></span>
                                            )}
                                            {data.isMandatory ? (
                                                <span className={`w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center`}>
                                                    <FaCircleExclamation size={18} />
                                                </span>
                                            ) : (
                                                <span className="w-5 h-5 rounded-full flex justify-center items-center"></span>
                                            )}
                                        </div>
                                        <div className="max-md:flex flex-col font-['Satoshi Variable'] gap-1 max-lg:hidden">
                                            <div className="flex">
                                                <span className="text-[#627BE8] font-bold text-xs">Job Type :</span>
                                                <span className="font-medium text-xs ml-2">{data?.jobType}</span>
                                            </div>
                                            <div className="flex">
                                                <span className="text-[#627BE8] font-bold text-xs">Name :</span>
                                                <span className="font-medium text-xs ml-2">{`${data.name} ${data.surname}`}</span>
                                            </div>
                                        </div>
                                        <div className="max-lg:flex max-md:hidden">
                                            <span className="text-[#627BE8] font-bold text-xs">Job Type :</span>
                                            <span className="font-medium text-xs ml-2">{data?.jobType}</span>
                                        </div>
                                        <div className="max-lg:flex max-md:hidden">
                                            <span className="text-[#627BE8] font-bold text-xs">Name :</span>
                                            <span className="font-medium text-xs ml-2">{`${data.name} ${data.surname}`}</span>
                                        </div>
                                        <div>
                                            <span className={``}>
                                                <img className="w-[30px] h-[30px]" src={`${openAcoordionResponsive === index ? upDirectionAerrow : downDirectionAerrow}`} alt="img" />
                                            </span>
                                        </div>
                                    </button>
                                    {isMobile < breakPoints.mobile ? (
                                        <div className={`${openAcoordionResponsive === index ? 'block' : 'hidden'} mt-3 border-t-2 border-[#C1C1C1] p-[10px]`}>
                                            <div className="mb-2 flex items-center">
                                                <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Email</span>
                                                <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                                <span className="font-['Satoshi Variable'] font-medium text-xs">{data.email ? data.email : '-'}</span>
                                            </div>
                                            <div className="mb-2 flex items-center">
                                                <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Recruited By</span>
                                                <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                                <span className="font-['Satoshi Variable'] font-medium text-xs">
                                                    {data.recruitedBy && data.recruitedBy !== '.' && data.recruitedBy !== '-' ? (
                                                        <div className="flex gap-1">
                                                            {data.recruitedBy}
                                                            <div className="flex items-center justify-center">
                                                                <Tooltip
                                                                    className="bg-black text-white max-w-[200px]"
                                                                    content={<>{`${data.recruitedBy} recruited total ${data.recruiterEmployeeCount} employees`}</>}
                                                                >
                                                                    <div className="w-4 h-4 ">
                                                                        <BsInfoCircle className="text-[#9a9fa3] w-4 h-4" />
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </span>
                                            </div>
                                            <div className="mb-2 flex items-center">
                                                <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Joined On</span>
                                                <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                                <span className="font-['Satoshi Variable'] font-medium text-xs">{GetJoinDate(data)}</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={`${openAcoordionResponsive === index ? 'block' : 'hidden'}`}>
                                            <div
                                                className={`${
                                                    openAcoordionResponsive === index ? 'flex' : 'hidden'
                                                } mt-3 border-t-2 border-[#C1C1C1] pt-[10px]  pr-[15px] pl-[15px] justify-between items-center`}
                                            >
                                                <div className="w-full">
                                                    <div className="mb-4 flex items-center">
                                                        <span className="w-[82px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Email</span>
                                                        <div className="">
                                                            <span className="mx-[10px] text-[#627BE8]">:</span>
                                                            <span className="font-['Satoshi Variable'] font-medium text-sm">{data.email ? data.email : '-'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-full">
                                                    <div className="mb-4 flex items-center">
                                                        <span className="w-[100px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Recruited By</span>
                                                        <div className="flex items-center justify-center">
                                                            <span className="mx-[10px] text-[#627BE8]">:</span>
                                                            <span className="font-['Satoshi Variable'] font-medium text-sm">
                                                                {data.recruitedBy ? (
                                                                    <div className="flex gap-1 font-['Satoshi Variable'] font-medium text-sm ">
                                                                        {data.recruitedBy}
                                                                        <div className="flex items-center justify-center">
                                                                            <Tooltip
                                                                                className="bg-black text-white max-w-[200px]"
                                                                                content={<>{`${data.recruitedBy} recruited total ${data.recruiterEmployeeCount} employees`}</>}
                                                                            >
                                                                                <div className="w-4 h-4 ">
                                                                                    <BsInfoCircle className="text-[#9a9fa3] w-4 h-4" />
                                                                                </div>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-full">
                                                    <div className="mb-4 flex items-center">
                                                        <span className="w-[82px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Joined On</span>
                                                        <div className="">
                                                            <span className="mx-[10px] text-[#627BE8]">:</span>
                                                            <span className="font-['Satoshi Variable'] font-medium text-sm">{GetJoinDate(data)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                </>
            )}
            <Paginator
                first={first}
                rows={10}
                totalRecords={employeeData.total}
                onPageChange={onPageChange}
                className="datatable_pagination datatable_pagination_joblist"
                template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            />
        </div>
    );
};

export default ResponsiveEmployeeList;
